import { useCallback } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import UserAvatar from '../../userAvatar';

const useStyles = makeStyles(({ palette: { primary }, spacing }) => ({
  root: {
    backgroundColor: primary.bluish9,
    borderRadius: 8,
    border: `1px solid ${primary.bluish9}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: spacing(2, 4, 2, 4),
  },
  candidate: {
    boxSizing: 'border-box',
    fontFamily: 'ProximaNova-Bold',
    fontSize: 16,
    lineHeight: '24px',
    width: '100%',
  },
  selected: {
    border: `1px solid ${primary.bluish1}`,
  },
  candidateLabel: {
    color: primary.bluish2,
    display: 'flex',
    width: '100%',
    minWidth: 0,
  },
  userAvatar: {
    width: '100%',
  },
  userAvatarCaption: {
    flexGrow: 1,
    minWidth: 0,
    alignItems: 'stretch',
  },
}));

const Candidate = ({
  className = undefined,
  user,
  label = '',
  hasLabel = false,
  hasEdit = false,
  isSelected = false,
  anonymousUser = false,
  editButton = () => {},
  onSelectCandidate = () => {},
}) => {
  const classes = useStyles();

  const handleSelect = useCallback(
    candidate => () => onSelectCandidate(candidate),
    [onSelectCandidate]
  );

  return (
    <div
      className={classNames(
        classes.root,
        { [classes.selected]: isSelected },
        className
      )}
      onClick={handleSelect(user)}
    >
      <UserAvatar
        className={classes.userAvatar}
        labelClass={classes.candidate}
        customCaptionContainerClass={classes.userAvatarCaption}
        captionDescriptionClass={classes.candidateLabel}
        user={user}
        captionDescription={label || '-'}
        withDescription={hasLabel}
        anonymousUser={anonymousUser}
        caption
        medium
      />
      {hasEdit && editButton()}
    </div>
  );
};

Candidate.propTypes = {
  className: PropTypes.string,
  user: PropTypes.shape({}).isRequired,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  hasLabel: PropTypes.bool,
  hasEdit: PropTypes.bool,
  anonymousUser: PropTypes.bool,
  editButton: PropTypes.func,
  onSelectCandidate: PropTypes.func,
};

export default Candidate;
